import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { FormattedHTMLMessage } from 'react-intl';
import { fetchProgramOrganizations } from '../lib/ServerApi/OrganizationApiClient';
import { OrganizationListComponent } from './OrganizationList/OrganizationListComponent';
import { OrganizationSearchResp, PropertiesOf, DatabaseId } from '../lib/types/types';
import { logger } from '../lib/utils/logger/logger';
import { SegmentEnum } from '../lib/types/runtimeTypes';


interface FetchOrganizationsProps {
    countryCode?: string;
    getItemProps: any;
    getMenuProps: any;
    highlightedIndex: any;
    itemToString: any;
    minimumSearchValueLength: number;
    onLoaded: any;
    programId: DatabaseId;
    searchValue: any;
    orgSearchUrl?: string;
}

interface FetchOrganizationState {
    isErrored: string;
    loading: boolean;
    organizations: OrganizationSearchResp;
}

class FetchOrganizations extends React.Component<FetchOrganizationsProps, FetchOrganizationState> {
    constructor(props) {
        super(props);
        this.state = {
            isErrored: null,
            loading: false,
            organizations: null,
        };
    }
    static initialState: FetchOrganizationState = { isErrored: null, loading: false, organizations: null };
    mounted = false;

    reset(overrides: PropertiesOf<FetchOrganizationState>) {
        this.setState({ ...FetchOrganizations.initialState, ...overrides });
    }

    fetch = async () => {
        const { orgSearchUrl, searchValue, countryCode } = this.props;
        if (!this.mounted) {
            return;
        }
        await fetchProgramOrganizations(orgSearchUrl, searchValue, countryCode).then(
            (organizations: OrganizationSearchResp) => {
                if (organizations) {
                    this.props.onLoaded(organizations);
                    this.setState({ organizations, loading: false });
                }
            },
        );
    }

    prepareFetch() {
        this.reset({ loading: true });
    }

    componentDidMount() {
        const { minimumSearchValueLength, searchValue } = this.props;
        this.mounted = true;

        if (searchValue.length >= minimumSearchValueLength) {
            this.prepareFetch();
            this.fetch();
        } else {
            logger.info(`No organizations fetched. Search term "${searchValue}" is less than ${minimumSearchValueLength} characters.`);
        }
    }

    componentDidUpdate(prevProps) {
        const { minimumSearchValueLength, searchValue } = this.props;

        if (prevProps.searchValue !== searchValue) {
            if (searchValue.length >= minimumSearchValueLength) {
                this.prepareFetch();
                this.fetch();
            } else {
                this.reset({ organizations: null, loading: false });
                logger.info(`No organizations fetched. Search term "${searchValue}" is less than ${minimumSearchValueLength} characters.`);
            }
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const { isErrored, loading, organizations } = this.state;
        const { getItemProps, getMenuProps, highlightedIndex, itemToString } = this.props;

        if (loading) {
            return (
                <div className={'sid-organization-list__menu'}>
                    <div className={'sid-organization-list__message'}>
                        {/* TODO: Define correct message ID from backend (backend need to send this message?) */}
                        <FormattedHTMLMessage
                            id="loading"
                            defaultMessage="Loading..."
                        />
                    </div>
                </div>
            );
        }
        if (isErrored) {
            return (
                <div className={'sid-organization-list__menu'}>
                    <div className={'sid-organization-list__message'}>
                        {/* TODO: Define correct message ID from backend (backend need to send this message?) */}
                        <FormattedHTMLMessage
                            id="errorId.unknownError"
                            defaultMessage="An unknown error occurred"
                        />
                    </div>
                </div>
            );
        }
        if (organizations && organizations.length > 0) {
            return (
                <OrganizationListComponent
                    getItemProps={ getItemProps }
                    getMenuProps= { getMenuProps }
                    highlightedIndex={ highlightedIndex }
                    itemToString={ itemToString }
                    organizations={ organizations }
                />
            );
        }
        return null;
    }
}

export const FetchOrganizationsComponent = FetchOrganizations;
